import { useSelector } from "react-redux";
import { MdVerified } from "react-icons/md";
import React, { useEffect, useState } from "react";
import { Box, Grid, Tooltip, Typography, Paper, Divider } from "@mui/material";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import ImagePopup from "./ImagePopup";
import { useAxios, useComponent, useLoader } from "../../hooks";
import LoadingButton from "../../components/LoadingButton";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import Error from "../Error/Error";
import pages from "../../constants/pages";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";
import { Loader } from "../../components";
import Color from "../../theme/color";

export default function IndependentAppointmentSummary() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { loader } = useComponent();
  const { eventID } = useParams();
  const { state, search } = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);

  const [redirectURL, setRedirectURL] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [checkFaceData, setCheckFaceData] = useState(false);
  const [checkContactDetails, setCheckContactDetails] = useState(false);

  const queryParams = new URLSearchParams(search);

  const entityID = queryParams.get("entity_id");
  const visitorID = queryParams.get("visitor_id");
  const bookingID = queryParams.get("booking_id");
  const userTypeId = queryParams.get("user_type_id");
  const digiLockerID = queryParams.get("id");

  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(state);
  const [premises, setPremisesData] = useState([]);

  const userPayloadString = localStorage.getItem(
    `userPayload_${visitorData.ID}`
  );

  const userPayload = JSON.parse(userPayloadString);

  let localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return item.includes(visitorData.ID) && !item.includes("userPayload");
  });

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });
    if (digiLockerID) {
      axios({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: "aadhar",
          request_id: digiLockerID,
          visitor_id: visitorData.ID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
        },
      }).then((response) => {
        if (response.status) {
          let key = visitorData.ID;
          localStorage.setItem(key, response.data.encrypted_face_data);
        }
      });
    }
  }, []);

  useEffect(() => {
    loader.start();
    let url = "admin/profile/get-visitor-booking-status";

    let method = "POST";

    let data = {
      visitor_id: visitorID,
      entity_id: entityID,
      user_type_id: userTypeId,
      booking_id: bookingID,
      face_data: getVisitorFaceData(visitorID),
    };

    axios({
      url: url,
      disableRedirect: true,
      method: method,
      data: data,
    }).then((response) => {
      if (response.status) {
        if (
          response.data[0].journey_status.consent &&
          response.data[0].journey_status.user_status == ""
        ) {
          navigate(
            pages.Success.route +
              `?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`
          );
        }
        setUserData({ userData: response.data });
      }
      loader.apiComplete();
    });
  }, [axios, eventID]);

  function handleSubmit() {
    let data = [];

    if (checkFaceData) {
      if (!data.includes("face")) {
        data.push("face");
      }
    } else {
      const faceIndex = data.indexOf("face");
      if (faceIndex !== -1) {
        data.splice(faceIndex, 1);
      }
    }

    if (checkContactDetails) {
      if (!data.includes("contact-details")) {
        data.push("contact-details");
      }
    } else {
      const contactIndex = data.indexOf("contact-details");
      if (contactIndex !== -1) {
        data.splice(contactIndex, 1);
      }
    }

    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });

    setLoading(true);
    axios({
      url: "event/visitor/save-consent",
      method: "POST",
      data: {
        ...(visitorID && { visitor_id: visitorID }),
        ...(bookingID && {
          booking_id: bookingID,
        }),
        entity_id: entityID,
        user_type_id: userTypeId,
        face_data: localStorageData[faceData[0]],
        consent_for: ["face", "contact-details"],
      },
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        navigate(
          pages.Success.route +
            `?visitor_id=${visitorID}&booking_id=${bookingID}&entity_id=${entityID}&user_type_id=${userTypeId}`
        );
        setOpenSuccess(response.status);
        setDisplayMessage(response.message.displayMessage);
        setStatus(response.status);
      } else {
        setOpen(!response.status);
        setDisplayMessage(response.displayMessage);
        setRedirectURL(response?.data?.redirect_url);
      }

      setLoading(false);
    });
  }

  useEffect(() => {
    axios({
      url: `/admin/profile/get-premises-banner?premises_id=` + entityID,
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setPremisesData(response.data);
      }
    });
  }, []);

  return (
    <Loader>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        sx={{
          backgroundColor: "#FFFFFF",
          // minHeight: "100vh",
          overflowY: "auto",
          py: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Paper
          elevation={4}
          sx={{
            borderRadius: "16px",
            padding: { xs: 2, sm: 3 },
            width: { xs: "92%", sm: "420px", md: "420px" },
            textAlign: "center",
            mt: { xs: 2, sm: 3 },
          }}
        >
          {/* Banner */}
          <Box
            component="img"
            src={
              premises.premises_banner ||
              userData?.userData[0]?.premises_image ||
              "data:image/png;base64,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"
            }
            alt="Event Banner"
            sx={{
              width: "100%",
              borderRadius: "12px",
              boxShadow: 2,
              mb: 3,
              objectFit: "cover",
              maxHeight: { xs: 110, sm: 190 },
            }}
          />

          {/* Title */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              mb: { xs: 3, sm: 4 },
              fontSize: { xs: "1.1rem", sm: "1.25rem" },
            }}
          >
            🎉 Registration Complete!
          </Typography>

          {/* Booking Details */}
          {userData?.userData?.map((item, index) => (
            <Paper
              key={index}
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "12px",
                p: 2,
                mb: 3,
                backgroundColor: "#FAFAFA",
              }}
            >
              <Typography
                variant="subtitle2"
                color="text.secondary"
                mb={1}
                textAlign="left"
              >
                #{index + 1} Booking Details
              </Typography>
              <Divider />

              <Grid container alignItems="center" mt={2}>
                <Grid item xs={9} textAlign="left" mb={2}>
                  <Typography variant="body1" fontWeight="bold" noWrap>
                    {item?.visitor_info?.first_name +
                      " " +
                      item?.visitor_info?.last_name}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    Booking ID: {item?.appointment_id}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    Officer Name: {item?.officer_name}
                  </Typography>
                </Grid>

                <Grid item xs={3} textAlign="right" mb={2}>
                  {item?.journey_status?.user_status === "Verify" ||
                  item?.journey_status?.user_status === "Add member" ? (
                    <NewReleasesIcon sx={{ color: "red", fontSize: 26 }} />
                  ) : (
                    <MdVerified size={26} color="green" />
                  )}
                </Grid>
              </Grid>
            </Paper>
          ))}

          {/* Message */}
          <Typography
            variant="body1"
            color="text.secondary"
            textAlign="justify"
            mb={3}
            sx={{ fontSize: { xs: "0.8rem", sm: "1rem" } }}
          >
            To make your access smooth and contactless, we need your consent to
            use the following as your digital ID for verification:
          </Typography>

          {/* Data Points */}
          <Box
            sx={{
              backgroundColor: "#F7FAFF",
              borderRadius: "8px",
              p: 2,
              mb: 3,
              textAlign: "left",
            }}
          >
            <Typography variant="body2" fontWeight="bold" mb={1}>
              🔹 Face token (your facial data)
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              🔹 Name
            </Typography>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="justify"
            mb={2}
          >
            Your data will be:
          </Typography>

          {/* Data Retention */}
          <Box
            sx={{
              backgroundColor: "#FFF8E1",
              borderRadius: "8px",
              p: 2,
              mb: 3,
              textAlign: "left",
            }}
          >
            <Typography variant="body2" mb={1}>
              • Kept securely for just <b>1 day</b> and automatically deleted
              afterward
            </Typography>
            <Typography variant="body2">
              • Used only for <b>access verification</b> (no marketing, no
              profiling)
            </Typography>
          </Box>

          <Typography
            variant="body2"
            color="text.secondary"
            textAlign="justify"
            mb={3}
          >
            By tapping <b>“I Agree”</b>, you give us permission to use your data
            for this purpose only.
          </Typography>

          {/* Button */}
          <Paper elevation={0} sx={{ borderRadius: "12px", mb: 3 }}>
            <Grid item xs={12}>
              <LoadingButton
                size="small"
                variant="outlined"
                onClick={handleSubmit}
                sx={{
                  fontSize: "12px",
                  px: 2,
                  py: 0.5,
                  border: `1px solid ${Color.digipass}`,
                  color: Color.digipass,
                  width: "100%",
                  backgroundColor: "white",
                  "&:hover": { backgroundColor: "#f9f9f9" },
                }}
                loading={loading}
              >
                I Agree & Share Consent
              </LoadingButton>
            </Grid>
          </Paper>

          {/* Error Dialog */}
          <Error
            open={open}
            setOpen={setOpen}
            ErrorMessage={displayMessage}
            handleOnClick={() => window.location.assign(redirectURL)}
            buttonContent={redirectURL ? "Verify Again" : ""}
          />
        </Paper>
      </Box>
    </Loader>
  );
}
